// extracted by mini-css-extract-plugin
module.exports = {"more":"homepage-module--more--1oKvT","about":"homepage-module--about--127q6","gallery":"homepage-module--gallery--1wCSx"};